import moment from "moment";

export const getOSBrowser = () => {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    }

    if (os != null) {
        document.body.classList.add('Mac-iOS');
    }
}
export const headerMenuLayoutFive = () => {
    if (!process.client) {
        return;
    }

    const textEl = document.querySelectorAll<HTMLElement>('.alt-menu-layout-5 > li .alt-menu-text');
    let maxHeight = 0;

    if (textEl.length > 0) {
        var textElArray = Array.from(textEl);
        textElArray.forEach((i) => {
            const height = i.clientHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        })

        textElArray.forEach((element) => {
            element.style.height = `${maxHeight}px`;
        });
    }
}

export const toggleHeaderUser = (event: Event) => {
    event.preventDefault();
    const isMobileScreen = window.innerWidth <= 1019;
    var targetElement = event.target as Element;

    const userHeaderEl = targetElement.closest('.alt-header-user');
    if (userHeaderEl && isMobileScreen) {
        userHeaderEl.classList.toggle("user-menu-active");
    }
}

export const headerUserMenuCloseOutside = () => {
    document.addEventListener("click", function (event) {
        var targetElement = event.target as Element;

        if (targetElement && !targetElement.closest('.alt-header-user') && document.getElementsByClassName('user-menu-active').length > 0) {
            toggleHeaderUser(event);
        }
    });
}

export const paddingListingProductMobile = (announcementBar: number) => {
    if (!process.client) {
        return;
    }

    const mobileFilter = document.querySelector(".mb-sidebar-left-list") as HTMLElement;

    if (mobileFilter !== null) {
        const announcementBarEl = document.getElementById("topbar") as HTMLElement;
        const adminBarEl = document.querySelector("#wpadminbar") as HTMLElement;
        const siteHeaderEl = document.querySelector(".site-header") as HTMLElement;

        if (window.innerWidth < 768) {
            var h_a = announcementBarEl.offsetHeight;
            let filterPadding2 = siteHeaderEl.offsetHeight;
            if (adminBarEl !== null && window.scrollY == 0) {
                filterPadding2 += adminBarEl.offsetHeight;
            }
            if (announcementBar == 0) {
                h_a = 0;
            }
            filterPadding2 = (filterPadding2 - h_a);
            mobileFilter.style.paddingTop = filterPadding2 + "px";
        } else {
            const wcHeaderTitleEl = document.querySelector(
                ".woocommerce-products-header__title"
            ) as HTMLElement;

            if (wcHeaderTitleEl) {
                wcHeaderTitleEl.style.paddingTop = "0px";
            }
        }
    }
}


export const scrollHeaderCheck = () => {
    const windowWidth = window.innerWidth;
    const masthead = document.getElementById('masthead');
    const main = document.getElementById('page');
    const cusstomSetElement = document.getElementById('pt-menu-mobile');
    const sub_header = document.getElementById('alt-header-sp');
    const filterSearch = document.getElementById('listing-actions-mobile')

    const announcementBarEl = document.getElementById('custom_menu');
    let topHeight = 0;
    if (announcementBarEl) {
        topHeight += announcementBarEl.offsetHeight;
    }
    let subHeaderHeight = 0;
    if (sub_header) {
        subHeaderHeight += sub_header.offsetHeight;
    }

    // if( windowWidth > 1019) {
    //     const headerTopEl = document.getElementById('alt-header-top');
    //     if( headerTopEl ) {
    //         topHeight += headerTopEl.offsetHeight;
    //     }
    // }

    const mbMenu = document.getElementById('alt-header-menu-sp');
    if (window.scrollY > 0) {
        if (masthead) {
            masthead.style.top = '-' + topHeight + 'px';
            masthead.classList.add('active_scroll');
            if (masthead.querySelector('.cs_announ_nomal')) {
                masthead.classList.add('active_scroll_nomal');
            }
            paddingListingProductMobile(1);
        }
        if (filterSearch) {
            filterSearch.style.top = subHeaderHeight + 'px';
        }

        if (main) {
            main.style.top = '0';
            main.classList.add('active_scroll_main');
        }
        if (mbMenu && masthead && announcementBarEl) {
            mbMenu.style.top = (masthead.clientHeight - announcementBarEl.offsetHeight - cusstomSetElement.offsetHeight) + 'px';
        }
    } else {
        if (masthead) {
            masthead.style.removeProperty('top');
            masthead.style.position = 'fixed';
            masthead.classList.remove('active_scroll');
            paddingListingProductMobile(0);
        }
        if (main) {
            main.classList.remove('active_scroll_main');
        }

        if (main && masthead) {
            main.style.top = masthead.clientHeight + 'px';
        }
        if (filterSearch) {
            filterSearch.style.top = (topHeight + subHeaderHeight) + 'px';
        }

        if (mbMenu && masthead) {
            mbMenu.style.top = (masthead.clientHeight - cusstomSetElement.offsetHeight) + 'px';
        }
    }
}

export const scrollHeader = () => {
    if (!process.client) {
        return;
    }

    window.addEventListener('scroll', () => {
        scrollHeaderCheck();
    });

    window.addEventListener('touchmove', () => {
        scrollHeaderCheck();
    });
}

export const hoverDirection = () => {
    const menuId = <HTMLDivElement>document.getElementById("mega-menu-main-navigation-1");
    let prevX: number | undefined, prevY: number | undefined, direction: string | undefined;

    menuId.addEventListener("mousemove", function (event) {
        var _eventTarget = event.target as HTMLElement;
        if (_eventTarget.tagName === "A") {
            if (prevX !== undefined && prevY !== undefined) {
                let deltaX = event.pageX - prevX;
                let deltaY = event.pageY - prevY;


                if (deltaX > 0) {
                    direction = "right";
                } else if (deltaX < 0) {
                    direction = "left";
                }


                // console.log("Mouse direction over link: " + direction);
                menuId.classList.remove('alt-hover-left');
                menuId.classList.remove('alt-hover-right');
                menuId.classList.add('alt-hover-' + direction);
            }

            // Update previous mouse coordinates
            prevX = event.pageX;
            prevY = event.pageY;
        }
    });
}
// window.addEventListener('DOMContentLoaded', () => {
//    paddingListingProductMobile(0);
//     console.log('DOM content loaded!');
// });

export const layout7HoverEffect = () => {
    var imgArr = [];
    const layoutEls = document.querySelectorAll('.alt-menu-layout-7');
    if (layoutEls.length > 0) {
        layoutEls.forEach((layoutEl, index) => {
            const col1 = layoutEl.querySelector('.alt-menu-col-1');
            if (col1) {
                const menuImages = col1.querySelectorAll('.alt-menu-image');
                if (menuImages.length > 0) {
                    menuImages.forEach((menuImage, index) => {
                        let img = menuImage.querySelector(".menu-alt-lazy-img")?.getAttribute("src");
                        imgArr.push(img);
                        if (index > 0) {
                            menuImage.style.display = 'none';
                        }
                    });
                }
                const menuItems = col1.querySelectorAll('.alt-submenu-item');

                const firstImage = col1.querySelector('.alt-menu-image');
                const firstImageUrl = firstImage?.lastElementChild?.lastElementChild?.getAttribute('src');
                if (menuItems.length > 0) {
                    menuItems.forEach((menuItem, index) => {
                        const imageEl = col1.querySelectorAll('.alt-menu-image')[index];
                        menuItem.addEventListener('mouseover', function (e) {
                            imageEl.style.display = 'block';
                            if (index > 0)
                                firstImage.style.display = 'none';
                        });
                        menuItem.addEventListener('mouseout', function (e) {
                            if (index > 0) {
                                imageEl.style.display = 'none';
                            }
                            firstImage.style.display = 'block';
                            // firstImage?.lastElementChild?.lastElementChild?.setAttribute('src', firstImageUrl);
                        });
                    });
                }
            }
        });
    }
}
